import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ActivityIcon, FlaskConicalIcon, HeartPulseIcon, LineChartIcon, LockIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Icon } from '../../components/icons/Icon';
import { SettingsGroup, SettingsRow } from '../../components/SettingsList';
import { useLocale } from '../../contexts/LocaleContext';

/** MOB/Profile/Health — hub for body composition, lab biomarkers and sport. */
export function ProfileHealth() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const rows = [{
    key: 'body',
    to: '/perfil/corpo',
    icon: <Icon name="heart" size={18} data-id="element-2784" data-mp="ciqzwifj8brk" />
  }, {
    key: 'biomarkers',
    to: '/perfil/saude/biomarcadores',
    icon: <Icon name="biomarker" size={18} data-id="element-2785" data-mp="7k618nfxi058" />
  }, {
    key: 'sports',
    to: '/perfil/esportes',
    icon: <Icon name="running" size={18} data-id="element-2786" data-mp="2xbaxmijlpabk" />
  }, {
    key: 'progress',
    to: '/perfil/grafico/body',
    icon: <Icon name="progress" size={18} data-id="element-2787" data-mp="2sa56gp5l9v45" />
  }];
  return <div className="px-2 pb-2" data-id="element-2788" data-mp="2sdj63pmvbq7w">
      <PageHeader title={t('health.title')} subtitle={t('health.subtitle')} showBack data-id="element-2789" data-mp="3cp45cf7tuw6w" />
      <SettingsGroup data-id="element-2790" data-mp="3grhb33mkqu3o">
        {rows.map(row => <SettingsRow key={row.key} label={t(`health.${row.key}`)} hint={t(`health.${row.key}Hint`)} icon={row.icon} onClick={() => navigate(row.to)} data-id="element-2791" data-mp="3gq65qzdhdeag" />)}
      </SettingsGroup>
      <p className="mt-2 flex items-start gap-1 px-1 text-[11px] leading-snug text-muted" data-id="element-2792" data-mp="2t14u739cpn0y">
        <LockIcon size={12} className="mt-[1px] shrink-0" aria-hidden="true" data-id="element-2793" data-mp="2xsmxhxyujzp3" />
        {t('health.private')}
      </p>
    </div>;
}